// extracted by mini-css-extract-plugin
export var communityPage = "community-module--communityPage--tiDbR";
export var minor = "community-module--minor--PffwO";
export var notice = "community-module--notice--gE20x";
export var Page = "community-module--Page--SZk8L";